var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cr-loader-wrap"},[_c('div',{staticClass:"cr-loader"},[_c('span',[_vm._v("{")]),_c('span',[_vm._v("}")]),_vm._v(" "),(_vm.text)?_c('div',{staticClass:"cr-loader-text"},[_vm._v(_vm._s(_vm.text))]):_vm._e()])])}
var staticRenderFns = []

export { render, staticRenderFns }